export default "/kiban/_next/static/images/referFriendsCouponBanner-bf78a47ab758d0806be5df2454989d41.png";